import React from 'react';
import { Button } from '../ui/button';
import { useAuth } from '../../contexts/AuthContext';

// Inline SVG – logos officiels Google et Apple (recommandé par vos choix 1B)
const GoogleLogo = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.153 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.651-.389-3.917z"/>
    <path fill="#FF3D00" d="M6.306 14.691l6.571 4.817C14.35 16.095 18.839 13 24 13c3.059 0 5.842 1.153 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.68 8.337 6.306 14.691z"/>
    <path fill="#4CAF50" d="M24 44c5.152 0 9.86-1.969 13.409-5.179l-6.19-5.238C29.152 35.755 26.69 36.8 24 36.8c-5.204 0-9.62-3.317-11.283-7.946l-6.52 5.024C9.527 40.02 16.219 44 24 44z"/>
    <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-0.793 2.239-2.225 4.154-3.994 5.583l0.003-0.002 6.19 5.238C40.861 35.508 44 30.214 44 24c0-1.341-0.138-2.651-0.389-3.917z"/>
  </svg>
);

const AppleLogo = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path fill="currentColor" d="M16.365 1.43c.043 1.07-.396 2.074-1.092 2.82-.73.78-1.92 1.38-3.063 1.296-.129-1.03.478-2.087 1.176-2.778.778-.75 2.127-1.29 2.979-1.338zM20.832 17.1c-.555 1.29-.82 1.86-1.536 3-.996 1.53-2.398 3.44-4.14 3.46-1.74.02-2.186-1.01-4.07-1.01-1.883 0-2.38.99-4.118 1.03-1.738.04-3.07-1.65-4.07-3.17-2.22-3.36-3.92-9.5-1.64-13.64C2.4 4.65 4.55 3.19 6.87 3.17c1.713-.03 3.332 1.14 4.07 1.14.738 0 2.788-1.41 4.7-1.2.798.03 3.06.32 4.51 2.37-3.99 2.19-3.35 7.94.682 11.62z"/>
  </svg>
);

const SocialLoginButtons = () => {
  const { socialLogin } = useAuth();

  const handleSocialLogin = () => {
    socialLogin();
  };

  return (
    <div className="space-y-3">
      {/* Google – bouton blanc, bord #DADCE0, texte #3C4043 */}
      <Button
        onClick={handleSocialLogin}
        variant="outline"
        aria-label="Se connecter avec Google"
        className="w-full h-12 text-base bg-white text-[#3C4043] border-[#DADCE0] hover:bg-white hover:border-[#BDC1C6]"
      >
        <div className="flex items-center justify-center">
          <div className="mr-3">
            <GoogleLogo size={20} />
          </div>
          Se connecter avec Google
        </div>
      </Button>

      {/* Apple – bouton noir, texte blanc */}
      <Button
        onClick={handleSocialLogin}
        aria-label="Se connecter avec Apple"
        className="w-full h-12 text-base bg-black text-white hover:bg-black/90"
      >
        <div className="flex items-center justify-center">
          <div className="mr-3 text-white">
            <AppleLogo size={20} />
          </div>
          Se connecter avec Apple
        </div>
      </Button>

      <p className="text-xs text-muted-foreground max-w-md mx-auto text-center">
        Connexion sécurisée via Emergent Auth. 
        Votre confidentialité est protégée et aucune donnée personnelle n'est partagée sans votre consentement.
      </p>
    </div>
  );
};

export default SocialLoginButtons;